import Layout from "@/layout";

const mainBodyRouter = {
    path: "/mainBody",
    component: Layout,
    redirect: "/mainBody/mainBodyManagement",
    name: "MainBody",
    alwaysShow: true,
    meta: {
        title: "主体管理",
        icon: "bizOrder",
    },
    children: [
        {
            path: "/mainBody/mainBodyManagement",
            name: "MainBodyManagement",
            component: () => import("@/views/mainBody/mainBodyManagement/index.vue"),
            meta: {
                title: "主体列表",
            },
        },
        {
            path: "/mainBody/CancellationApplicationList",
            name: "CancellationApplicationList",
            component: () => import("@/views/mainBody/CancellationApplicationList/index.vue"),
            meta: {
                title: "注销申请",
            },
        },
    ],
};

export default mainBodyRouter;
